import React, { FC, useMemo } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import { Toolbar } from "./Toolbar";
import { getEditorConfig } from "./constants/editorConfig";
import { TextEditorProps } from "./types";
import "./styles.scss";

export const TextEditor: FC<TextEditorProps> = (props) => {
  // IMPORTANT : config memoized and computed only once on component mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const config = useMemo(() => getEditorConfig(props), []);
  const editor = useEditor(config);

  return (
    <div className="editor">
      <Toolbar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
};
